import React from 'react';
import { Modal, ModalBody, Button } from 'reactstrap';
import { IconGift, IconExternalLink } from '@tabler/icons-react';
import { useMemoryGameStore } from '../../../stores/index.js';
import { renderMarkdownToReact } from '@core/frontend/ui';
import styles from './GoldenModal.module.scss';

const GoldenModal = ({ backdropClassName }) => {
    const {
        isGoldenModalOpen: isOpen,
        goldenFact,
        closeGoldenModal: onClose,
        redeemTicket: onRedeem,
    } = useMemoryGameStore();

    if (!isOpen) return null;

    const hasLink = goldenFact?.linkUrl && goldenFact.linkUrl !== '#';
    const destinationUrl = hasLink ? goldenFact.linkUrl : null;
    const isExternal =
        destinationUrl && (destinationUrl.startsWith('http://') || destinationUrl.startsWith('https://'));

    return (
        <Modal
            isOpen={isOpen}
            toggle={onClose}
            centered
            className="mx-auto"
            contentClassName="border-0 shadow-lg"
            backdrop="static"
            backdropClassName={backdropClassName}
            style={{ maxWidth: '360px' }}
        >
            <ModalBody
                className={`${styles.modalContent} text-center p-4 d-flex flex-column align-items-center gap-3 text-dark rounded-3`}
            >
                <div className="d-flex align-items-center justify-content-center my-1">
                    <IconGift size={36} stroke="var(--bs-dark, #212529)" strokeWidth={2.5} />
                </div>

                <div className="w-100">
                    <h2 className="h5 text-dark mb-1 fw-bold">{goldenFact?.headline || 'Gewinn-Ticket gefunden!'}</h2>
                    <p className="small text-dark mb-0 fw-bold">
                        {renderMarkdownToReact(goldenFact?.copy || 'Chance auf 1 von 100 Wunschgutscheine sichern!')}
                    </p>
                </div>

                {hasLink ? (
                    <Button
                        href={destinationUrl}
                        tag="a"
                        target="_blank"
                        rel="noopener"
                        color="white"
                        className="w-100 fw-bold py-2 mt-2 anl_memory-game--golden-link-btn"
                    >
                        <span className="d-flex align-items-center justify-content-center gap-1">
                            {goldenFact?.linkButtonText || 'Sofort einlösen'}
                            {isExternal && <IconExternalLink size={16} />}
                        </span>
                    </Button>
                ) : (
                    <Button
                        type="button"
                        onClick={() => onRedeem()}
                        color="white"
                        className="w-100 fw-bold py-2 mt-2 anl_memory-game--golden-redeem-btn"
                    >
                        <span className="d-flex align-items-center justify-content-center gap-1">
                            {goldenFact?.linkButtonText || 'Sofort einlösen'}
                        </span>
                    </Button>
                )}

                <Button
                    type="button"
                    onClick={onClose}
                    color="light"
                    outline
                    className="w-100 mt-2 fw-semibold py-2 anl_memory-game--golden-continue-btn"
                >
                    <span className="d-flex align-items-center justify-content-center gap-1">
                        {goldenFact?.continueButtonText || 'Später einlösen & weiterspielen'}
                    </span>
                </Button>
            </ModalBody>
        </Modal>
    );
};

export default GoldenModal;
